import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, Link } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
  CftTank,
} from "../../../components";
import routes from "../../../utils/cftRoutes";
import { useCft } from "../../../utils/CftProvider";

import SoilWaterFootprintForm, {
  SoilWaterFootprintFormContext,
} from "../../../forms/farmlands/waterFootprint/SoilWaterFootprintForm/SoilWaterFootprint.form";

function SoilWaterFootprintPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveWaterFootprint, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={33}
          cropName={meta.title.waterFootprint}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="waterFootprint" />

              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveWaterFootprint({
                    soil: values,
                  });
                  history.push(routes.FARMLANDS.WATER_FOOTPRINT.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:soil.title", "Charakterystyka gleby")}
          onBack={() => history.push(routes.FARMLANDS.WATER_FOOTPRINT.DETAILS)}
          onNext={submitForm}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:soil.title", "Charakterystyka gleby")}</h3>
            <p>
              {t(
                "cft:soil.subtitle",
                "W swojej ocenie określ charakterystykę gleby na polu."
              )}
            </p>
            <p className="soil-page__article">
              {t(
                "cft:soil.article",
                "Jeśli nie wiesz, gdzie zodbyć informację o glebie, przejdź do artykułu"
              )}
              <Link to="/articles/obecny-system-badania-probek-gleb-w-polsce">
                {t(
                  "cft:soil.link",
                  "Czym jest i gdzie sprawdzę swoją charakterystykę gleby"
                )}
              </Link>
            </p>
          </>
        }
      >
        <SoilWaterFootprintForm />
        <CftReportProgress type="waterFootprint" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <SoilWaterFootprintFormContext>
      <SoilWaterFootprintPage />
    </SoilWaterFootprintFormContext>
  );
};
